/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCarePatientDetailsUploadDocumentsRequest
 */
export interface MatrixCarePatientDetailsUploadDocumentsRequest {
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    push_insurance_eligibility_check_results?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    push_clinic_package?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    push_full_clinic_package?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    clinic_package_document_ids?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    push_generated_document_types?: Array<MatrixCarePatientDetailsUploadDocumentsRequestPushGeneratedDocumentTypesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixCarePatientDetailsUploadDocumentsRequest
     */
    push_additional_document_ids?: Array<string>;
}


/**
 * @export
 */
export const MatrixCarePatientDetailsUploadDocumentsRequestPushGeneratedDocumentTypesEnum = {
    SummaryReport: 'summary_report',
    RulesReport: 'rules_report',
    DataPullsReport: 'data_pulls_report',
    SOffenderReport: 's_offender_report',
    MedicationsReport: 'medications_report',
    InsuranceEligibilityCheck: 'insurance_eligibility_check',
    AdvancedAiInsuranceCheck: 'advanced_ai_insurance_check',
    PalAuthSubmissionPackage: 'pal_auth_submission_package'
} as const;
export type MatrixCarePatientDetailsUploadDocumentsRequestPushGeneratedDocumentTypesEnum = typeof MatrixCarePatientDetailsUploadDocumentsRequestPushGeneratedDocumentTypesEnum[keyof typeof MatrixCarePatientDetailsUploadDocumentsRequestPushGeneratedDocumentTypesEnum];


/**
 * Check if a given object implements the MatrixCarePatientDetailsUploadDocumentsRequest interface.
 */
export function instanceOfMatrixCarePatientDetailsUploadDocumentsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MatrixCarePatientDetailsUploadDocumentsRequestFromJSON(json: any): MatrixCarePatientDetailsUploadDocumentsRequest {
    return MatrixCarePatientDetailsUploadDocumentsRequestFromJSONTyped(json, false);
}

export function MatrixCarePatientDetailsUploadDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCarePatientDetailsUploadDocumentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'push_insurance_eligibility_check_results': !exists(json, 'push_insurance_eligibility_check_results') ? undefined : json['push_insurance_eligibility_check_results'],
        'push_clinic_package': !exists(json, 'push_clinic_package') ? undefined : json['push_clinic_package'],
        'push_full_clinic_package': !exists(json, 'push_full_clinic_package') ? undefined : json['push_full_clinic_package'],
        'clinic_package_document_ids': !exists(json, 'clinic_package_document_ids') ? undefined : json['clinic_package_document_ids'],
        'push_generated_document_types': !exists(json, 'push_generated_document_types') ? undefined : json['push_generated_document_types'],
        'push_additional_document_ids': !exists(json, 'push_additional_document_ids') ? undefined : json['push_additional_document_ids'],
    };
}

export function MatrixCarePatientDetailsUploadDocumentsRequestToJSON(value?: MatrixCarePatientDetailsUploadDocumentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'push_insurance_eligibility_check_results': value.push_insurance_eligibility_check_results,
        'push_clinic_package': value.push_clinic_package,
        'push_full_clinic_package': value.push_full_clinic_package,
        'clinic_package_document_ids': value.clinic_package_document_ids,
        'push_generated_document_types': value.push_generated_document_types,
        'push_additional_document_ids': value.push_additional_document_ids,
    };
}

